// Loader.js
import React from 'react';
import './Loader.css'; // Import corresponding CSS file for styling

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="loader"></div>
    </div>
  );
};

export default Loader;